import { useMutation } from '@tanstack/react-query'

import { useApiClient } from '@/api/ApiClientProvider'
import type { AdvertisingQuery } from '@/api/types'
import { saveBlob } from '@/features/analytics/traffic/download'

import { csvFilename } from './download'
import { advertisingErrorMessage } from './errors'

/** Downloads the table on screen as CSV, the same shape `CsvButton` on Traffic uses. */
export function CsvButton({ query }: { query: AdvertisingQuery }) {
  const client = useApiClient()
  const download = useMutation({
    mutationFn: () => client.advertisingCampaignsCsv(query),
    onSuccess: (blob) => saveBlob(blob, csvFilename(query)),
  })
  return (
    <>
      <button type="button" className="ci-button" disabled={download.isPending} onClick={() => download.mutate()}>
        {download.isPending ? 'Preparing CSV…' : 'Download CSV'}
      </button>
      {download.isError ? (
        <p role="alert" className="adv-error">
          {advertisingErrorMessage(download.error, 'The CSV could not be prepared just now. Try again in a moment.')}
        </p>
      ) : null}
    </>
  )
}
